<template>
  <v-app light>
    <!--<hoofdscherm></hoofdscherm>-->
    <router-view></router-view>
  </v-app>
</template>

<script>
  import hoofdscherm from '@/components/hoofdscherm.vue'


  export default {
    data () {
      return {

      }
    },
    components:{
      hoofdscherm:hoofdscherm
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue